module.exports = __webpack_public_path__ + "img/canbadge_round_100mm_line.2d11f96c.png";